module.exports = __webpack_public_path__ + "static/media/frames-17.16de10f4.jpg";